import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to category management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  CATEGORY_MANAGEMENT: {
    path: `${baseRoutes.adminBaseRoutes}/category-management`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-list-thumb" />
      </span>
    ),
  }
};

export default accessRoute;
